<template>
    <div class="risk"
         role="img"
         :aria-label="ariaLabel"
    >
        <span
            v-for="i in 5"
            :key="i"
            class="dot"
            aria-hidden="true"
            :style="{
                '--progress': getDotProgress(riskScore, i) + '%',
                '--color': getDotColor(i)
            }"
        ></span>
        <span class="risk-text" aria-hidden="true">{{ riskScore }}/5</span>
    </div>
</template>

<script setup>
    import { computed } from 'vue';

    const props = defineProps({
        riskScore: {
            type: Number,
            required: true,
            validator: value => {
                if (value < 0 || value > 5) {
                    console.warn(`Riesgo.vue: riskScore debe estar entre 0 y 5, recibido: ${value}`);
                    return false;
                }
                return true;
            }
        }
    });

    const ariaLabel = computed(() => {
        const nivel = getNivelRiesgo(props.riskScore);
        return `Nivel de riesgo: ${props.riskScore} de 5 - ${nivel}`;
    });

    const getNivelRiesgo = risk => {
        if (risk <= 1) return 'Muy bajo';
        if (risk <= 2) return 'Bajo';
        if (risk <= 3) return 'Medio';
        if (risk <= 4) return 'Alto';
        return 'Muy alto';
    };

    const getDotProgress = (risk, index) => {
        const lower = index - 1;
        const upper = index;

        if (risk <= lower) return 0;
        if (risk >= upper) return 100;

        return (risk - lower) * 100;
    };

    const getDotColor = index => {
        const colors = ['#00c853', '#7cb342', '#ffb300', '#ff6f00', '#ff1744'];
        return colors[index - 1];
    };
</script>

<style scoped>
    .risk {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
    }
    .dot {
        width: 16px;
        height: 16px;
        flex: 0 0 16px;
        border-radius: 50%;
        background: linear-gradient(
            to right,
            var(--color) var(--progress),
            #e5e5e5 0
        );
    }
    .risk-text {
        font-weight: 600;
        padding-left: 4px;
        letter-spacing: 0.8px;
    }
</style>